/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_Extract_Closed_LogInputs */



/**
* | output |
* | --- |
* | "[DRASTIC close]: Closed caption extraction process closed" |
*
* @param {Drastic_Tech_Extract_Closed_LogInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_extract_closed_log = /** @type {((inputs?: Drastic_Tech_Extract_Closed_LogInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Extract_Closed_LogInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("[DRASTIC fermeture] : Processus d'extraction des sous-titres termine")
	if (locale === "de") return /** @type {LocalizedString} */ ("[DRAMATISCHES Ende]: Der Prozess zur Extraktion der Untertitel wurde beendet.")
	if (locale === "it") return /** @type {LocalizedString} */ ("[Chiusura DRASTICA]: Processo di estrazione dei sottotitoli chiuso")
	if (locale === "ru") return /** @type {LocalizedString} */ ("[КРАЙНЕЕ ЗАВЕРШЕНИЕ]: Процесс извлечения субтитров завершен")
	if (locale === "es") return /** @type {LocalizedString} */ ("[Cierre DRÁSTICO]: Proceso de extracción de subtítulos cerrado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("【字幕提取流程已关闭】")
	if (locale === "ja") return /** @type {LocalizedString} */ ("[DRASTIC 終了]: クローズドキャプション抽出プロセスが終了しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("[अत्यावश्यक समाप्ति]: क्लोज्ड कैप्शन निकालने की प्रक्रिया बंद कर दी गई है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("[Fechamento drástico]: Processo de extração de legendas encerrado")
	return /** @type {LocalizedString} */ ("[DRASTIC close]: Closed caption extraction process closed")
});